"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApolloRestClient = void 0;
var _client = require("@apollo/client");
var _retry = require("@apollo/client/link/retry");
var _apolloLinkRest = require("apollo-link-rest");
var _apolloLinkTimeout = _interopRequireDefault(require("apollo-link-timeout"));
var _timeouts = require("../constants/timeouts");
const RETRY_OPTIONS = {
  delay: {
    initial: 1000,
    max: 3000
  },
  attempts: {
    max: 5
  }
};
const getTimeoutLink = () => new _apolloLinkTimeout.default(_timeouts.timeouts.NAV_TIMEOUT);
const getRetryLink = () => new _retry.RetryLink(RETRY_OPTIONS);
const getRestLink = uri => new _apolloLinkRest.RestLink({
  uri,
  credentials: 'include'
});
const getTimeoutRestLink = uri => {
  const restLink = getRestLink(uri);
  const timeoutLink = getTimeoutLink();
  // @ts-ignore
  return timeoutLink.concat(restLink);
};
// @ts-ignore
const getApolloLink = uri => _client.ApolloLink.from([getRetryLink(), getTimeoutRestLink(uri)]);
const getApolloRestClient = feedUrl => {
  const cache = new _client.InMemoryCache();
  return new _client.ApolloClient({
    link: getApolloLink(feedUrl),
    cache
  });
};
exports.getApolloRestClient = getApolloRestClient;